import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCart } from 'lucide-react';
const NAMES = ['Martín', 'Lucía', 'Santiago', 'Valentina', 'Mateo', 'Sofía', 'Nicolás', 'Camila', 'Tomás', 'Florencia', 'Agustín', 'Julieta', 'Benjamín', 'Catalina', 'Facundo'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Bahía Blanca', 'Resistencia', 'Posadas', 'San Luis'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setCurrentData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      showPopup();
      // Then set interval for subsequent popups (random between 8-15s)
      const interval = setInterval(() => {
        showPopup();
      }, Math.floor(Math.random() * 7000) + 8000);
      return () => clearInterval(interval);
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  return <AnimatePresence data-id="element-174">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -100,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -100,
      y: 20
    }} transition={{
      type: 'spring',
      stiffness: 200,
      damping: 20
    }} className="fixed bottom-4 left-4 z-50 max-w-sm" data-id="element-175">
          <div className="bg-[#1a1f35] border-l-4 border-[#22c55e] rounded-r-lg shadow-2xl p-4 flex items-center space-x-4" data-id="element-176">
            <div className="bg-[#22c55e]/20 p-2 rounded-full" data-id="element-177">
              <ShoppingCart className="w-5 h-5 text-[#22c55e]" data-id="element-178" />
            </div>
            <div data-id="element-179">
              <p className="text-white text-sm" data-id="element-180">
                <span className="font-bold" data-id="element-181">{currentData.name}</span> de{' '}
                {currentData.city}
              </p>
              <p className="text-xs text-gray-400 mt-0.5" data-id="element-182">
                acaba de comprar el Kit Viral
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}